<template>
  <JobBadge badge-text="Evergreen">
    <template #title>
      Evergreen Job Post
    </template>

    <template #text>
      Evergreen posts purposely stay open for an extended period of time to collect
      a pool of candidates for high-volume roles.
    </template>
  </JobBadge>
</template>

<script>
import JobBadge from '@/components/editor/badge/JobBadge.vue';

export default {
  name: 'JobBadgeEvergreen',
  components: { JobBadge },
};
</script>
